import { PROMO } from 'apps/promo/constants/EntryPoint';
import { NO_AUTH_VIEW } from 'apps/promo/constants/ServerConstants';
import ApplePayPage from 'apps/promo/pages/ApplePayPage';
import SupportedCountriesPage from 'apps/promo/pages/help/SupportedCountriesPage';
import LibreNoAuthChequePage from 'apps/promo/pages/info/LibreNoAuthChequePage';
import LicensePage from 'apps/promo/pages/LicensePage';
import MarketingTermsAndConditionsPage from 'apps/promo/pages/marketing/MarketingTermsAndConditionsPage';
import PartnersPage from 'apps/promo/pages/PartnersPage';
import PaysendMoneyPage from 'apps/promo/pages/PaysendMoneyPage';
import AcceptInvitePage from 'apps/promo/pages/referral/AcceptInvitePage';
import DailyPayPage from 'apps/promo/pages/referral/DailyPayPage';
import JetBluePage from 'apps/promo/pages/referral/JetBluePage';
import ReferralPageC3P0 from 'apps/promo/pages/referral/ReferralPageC3P0';
import SamsungPayPage from 'apps/promo/pages/SamsungPayPage';
import SelectRegionPage from 'apps/promo/pages/SelectRegionPage';
import StablecoinPage from 'apps/promo/pages/StablecoinPage';
import StatusNoAuthPage from 'apps/promo/pages/StatusNoAuthPage';
import UvnPage from 'apps/promo/pages/UvnPage';
import VisaPage from 'apps/promo/pages/VisaPage';
import WhiteScreenMobileAppPage from 'apps/promo/pages/WhiteScreenMobileAppPage';
import { FOOTER_TYPE_DEFAULT, FOOTER_TYPE_SIMPLE, LANG_COUNTRY } from 'apps/promo/routes/routeConstant';
import { modifyReferralPageStrapiApi } from 'apps/promo/routes/strapiApiModifiers';

const noAuth = [
    {
        path: [
            `/${LANG_COUNTRY}/supported_countries`,
            `/${LANG_COUNTRY}/supported-countries`,
            `/${LANG_COUNTRY}/help/info/supported_countries`,
            `/${LANG_COUNTRY}/help/info/supported-countries`,
        ],
        exact: true,
        component: SupportedCountriesPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v1/supported-country',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
    },
    {
        path: ['/select-region', `/${LANG_COUNTRY}/select-region`],
        component: SelectRegionPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/v1/select-region',
            entryPoint: PROMO,
            footerType: FOOTER_TYPE_DEFAULT,
            strapiApiUseCache: true,
        },
    },
    {
        path: ['/partners', `/${LANG_COUNTRY}/partners`],
        component: PartnersPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            strapiApi: '/api/v2/partners',
            entryPoint: PROMO,
            footerType: FOOTER_TYPE_SIMPLE,
            menuSection: 'company',
            strapiApiUseCache: true,
        },
        renderOptions: {
            isHR: true,
        },
    },
    {
        path: [`/${LANG_COUNTRY}/apple-pay`],
        component: ApplePayPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v2/apple-pay-v2',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
        renderOptions: {
            isApplePay: true,
        },
    },
    {
        path: [`/${LANG_COUNTRY}/samsung-pay`],
        component: SamsungPayPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v2/samsung-pay',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
        renderOptions: {
            isGlobalAccountHelp: true,
        },
    },
    {
        path: ['/web/pay/accepted'],
        component: WhiteScreenMobileAppPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        isPathWithoutFooter: false,
        stateOptions: {
            entryPoint: PROMO,
        },
    },
    {
        path: ['/success', '/fail', '/waiting', '/close'],
        component: StatusNoAuthPage,
        view: NO_AUTH_VIEW,
        stateOptions: {
            entryPoint: PROMO,
        },
    },
    {
        path: ['/license/us', `/${LANG_COUNTRY}/license/us`],
        component: LicensePage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v1/license-us',
            pageName: 'other',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
    },
    {
        path: ['/libre/:requestKey'],
        component: LibreNoAuthChequePage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v2/libre-page/{:requestKey}',
            footerType: FOOTER_TYPE_DEFAULT,
            noIndex: true,
        },
        renderOptions: {
            isLibre: true,
        },
    },
    {
        path: ['/es-us/uvn'],
        component: UvnPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v1/uvn-page',
            pageName: 'landing',
            menuSection: 'personal',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
            noIndex: true,
        },
        renderOptions: {
            hideFooterCountryLang: true,
        },
    },
    {
        path: ['/c3/referral', `/${LANG_COUNTRY}/c3/referral`],
        component: ReferralPageC3P0,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v1/accept-invite-page',
            modifyStrapiApi: modifyReferralPageStrapiApi,
            pageName: 'landing',
            menuSection: 'personal',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
            noIndex: true,
        },
        renderOptions: {
            hideNavigation: true,
        },
    },
    {
        path: ['/referral/:code', '/dl/referral/:code', `/${LANG_COUNTRY}/referral/:code`],
        component: AcceptInvitePage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v1/accept-invite-page/{:code}',
            pageName: 'landing',
            menuSection: 'personal',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
            noIndex: true,
        },
        renderOptions: {
            hideNavigation: true,
            isReferralPage: true,
        },
    },
    {
        path: ['/marketing-tc', `/${LANG_COUNTRY}/marketing-tc`],
        component: MarketingTermsAndConditionsPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v1/marketing-terms-and-conditions-page',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
    },
    {
        path: ['/dailypay', `/${LANG_COUNTRY}/dailypay`],
        component: DailyPayPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v1/dailypay-page',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
        renderOptions: {
            headerHidden: true,
        },
    },
    {
        path: ['/jetblue', `/${LANG_COUNTRY}/jetblue`, '/JetBlue', `/${LANG_COUNTRY}/JetBlue`],
        component: JetBluePage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v1/jet-blue-page',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
        renderOptions: {
            headerHidden: true,
        },
    },
    {
        path: ['/stablecoin', `/${LANG_COUNTRY}/stablecoin`],
        component: StablecoinPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v1/stablecoin-page',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
        renderOptions: {
            isBusinessConnect: true,
            promoDarkPage: true,
        },
    },
    {
        path: ['/visa', `/${LANG_COUNTRY}/visa`],
        component: VisaPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v1/visa-page',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
    },
    {
        path: ['/paysend-money-2020-2026', `/${LANG_COUNTRY}/paysend-money-2020-2026`],
        component: PaysendMoneyPage,
        view: NO_AUTH_VIEW,
        isAuthZone: false,
        doNotGetDataFromTomcat: true,
        stateOptions: {
            entryPoint: PROMO,
            strapiApi: '/api/v1/paysend-money-page',
            strapiApiUseCache: true,
            footerType: FOOTER_TYPE_DEFAULT,
        },
        renderOptions: {
            promoDarkFooter: true,
            blackLogo: true,
        },
    },
];

export default noAuth;
